<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
   <div style="position: fixed;z-index: 99;width:91%;display: flex; background-color: #fff;">
    <div class="flexTitle">
      <div class="flex">
        <div class="m-r-10">角色：</div>
        <div>{{ roleTitle }}</div>
      </div>
      <div class="flex">
        <div class="m-r-10">拥有员工：</div>
        <div v-if="RoleStaff.length==0">--</div>
        <div style="margin: 0 10px;" v-for="(item, index) in RoleStaff" :key="index">{{ item.name }}</div>
      </div>
     
    </div>
    <div class="flex">
        <el-button style="float: right" type="warning" @click="handleBackClick" size="small">返回</el-button>
        <el-button type="warning" plain @click="handleSubmitClick" size="small">提交</el-button>
      </div>
   </div>
    <!-- 表格 -->
    <!-- <div>{{ defaultProps }}</div> -->
    <div class="pageTR">
      <div class="dataView" v-for="(item, index) in states" :key="index">
        <div
          class="dataTab"
          :class="state == item.title ? 'activeData' : ''"
          @click="tab(index, item)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
    <el-tree
    class="tree"
      :data="RoleTree"
      :props="defaultProps"
      show-checkbox
      node-key="code"
      ref="rightsTree"
      default-expand-all
      :current-node-key="roleSelected"
      :default-checked-keys="roleArray"
      :render-content="renderContent"
    >
    </el-tree>
    <span  class="footer">
	
			</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fixedHeight: "",
      comTab: 1,
      RoleTree: [], //tree树
      defaultProps: {
        children: "childs",
        label: "title",
      },
    
      RoleStaff: [], //角色下员工列表
      stateList: { title: "o2o", code: "o2o" }, //选中的系统
      state: "o2o", //状态
      states: [
       
      ], //状态列表
      roleTitle: this.$route.query.title,
      roleSelected: "",
      roleArrayItem:[],//回显默认选中的一组数据
      roleArray: [],//回显默认选中的
      RoleParams:[],//提交选中的数组
      renderContent:function (h,{node,data,store}) {
                    let addElement = arguments[0];
                    if(data.menu_type == 3){
                        return addElement('span',[
                            addElement('i',{class:"el-icon-mouse"}),
                            addElement('span',"    "),
                            addElement('span',arguments[1].node.label)
                        ]);
                    }else if(data.menu_type == 2){
                        return addElement('span',[
                            addElement('i',{class:"el-icon-s-order"}),
                            addElement('span',"    "),
                            addElement('span',arguments[1].node.label)
                        ]);
                    }else if(data.menu_type == 1){
                        return addElement('span',[
                            addElement('i',{class:"el-icon-s-tools"}),
                            addElement('span',"    "),
                            addElement('span',arguments[1].node.label)
                        ]);
                    }
                }
    };
  },
  mounted() {
    this.getsystemList();
    this.getRoleTree(); //查看
    this.getRoleStaff();
    this.fixedHeight = document.documentElement.clientHeight - 76;
  },
  methods: {
    getsystemList() {
      this.$http.get(process.env.VUE_APP_zichan + '/api/SystemRights/system/list').then(res => {
        if (res.code == 0) {
          this.states = res.data
          
        }
      })
    },
    // 返回
    handleBackClick() {
      this.$router.go(-1);
    },
    handleSelectionChange() {},
    tab(index, item) {
      this.stateList = item;
      this.state = item.title;
      this.RoleTree = [];
      this.getRoleTree();
      this.RoleParams = []
    },
    // 获取菜单树
    getRoleTree() {
      let params = {
        systemCode: this.stateList.code,
        roleId: this.$route.query.id,
      };
      this.$http
        .get(process.env.VUE_APP_zichan + "/api/SystemRights/menu/roleTree", params)
        .then((res) => {
          if (res.code == 0) {
            console.log(res.data[0].rights_info);

            const circulation = (roleTreeArray) => {
              roleTreeArray.forEach((item) => {
                if (item.is_check) {
                  this.roleArray.push(item.code);
                }
                if (item.childs && item.childs.length) {
                  circulation(item.childs);
                }
              });
            };
            //把数列表拿到
            this.RoleTree = res.data[0].rights_info;
            //递归判断is_check为true 就添加到默认勾选中
            circulation(this.RoleTree);
          }
        });
    },
    // 获取角色下员工
    getRoleStaff() {
      let params = {
        roleId: this.$route.query.id,
      };
      this.$http
        .get(process.env.VUE_APP_zichan + "/api/SystemRights/role/staffs", params)
        .then((res) => {
          if (res.code == 0) {
            this.RoleStaff = res.data;
          }
        });
    },
    // 提交
    handleSubmitClick(){
    let parentList = this.$refs.rightsTree.getHalfCheckedNodes()
    let chirenldList = this.$refs.rightsTree.getCheckedNodes()
    let arr=[...parentList,...chirenldList];
    this.RoleParams=arr
      this.$confirm("确定提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

    let params = {
      menu_list: this.RoleParams,
       role_id: this.$route.query.id,
        system_info:this.stateList
      };
      this.$http
        .post(process.env.VUE_APP_zichan + "/api/SystemRights/role/bindRights", params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "更改成功",
            });
            this.getRoleTree(); 
            this.$router.go(-1);
          }
        })
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;

  .flexTitle {
    width: 100%;
    display: flex;
   
  }
.tree{

  margin-top: 20px;
}
  .flex {
    display: flex;
    align-items: center;
    padding: 15px 10px;
    margin: 5px 10px;
  }

  .tableTitle {
    margin: 20px 0;
    border-left: 5px solid #f5882a;
  }

  .pageTR {
    width: 200px;
    margin-right: 46px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 80px;

    .dataView {
      // display: flex;
      // justify-content: space-around;

      font-size: 15px;
      font-weight: bold;

      .dataTab {
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }

      .activeData {
        color: #f5882a;
        border-bottom: 2px solid #f5882a;
      }
    }
  }
  .footer{
    margin: 20px auto;
  }
}
</style>
